














import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component

export default class DownloadComponent extends Vue {

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        switch(newVal.params.type) {
            case 'budget': 
                let appId = parseInt(newVal.params.appId);
                let novalue: any;
              const cn=  newVal.params.entity =="ConceptNote"? "CN-":"";
                novalue=`Budget_${newVal.params.entity }_${cn}${appId}`
                this.$services.budget.exportToExcel(appId, novalue, newVal.params.entity || "Application")
            break;
            
            case 'document': 
                this.$services.document.externalDownload(newVal.params.appId)
            break;
        }
    }

}
